<template>
  <section class="requirement page">
    <section class="main">
      <div class="top">
        <img class="top-bg" src="../assets/views/rq-banner@2x.png" />
        <div class="top-title">欢迎加入小拉出行</div>
      </div>
      <div class="content">
        <div class="reason-container">
          <div class="title">为什么加入小拉出行？</div>
          <section class="reason-list">
            <section class="reason-item">
              <img
                class="item-icon"
                src="../assets/views/requirement-order@2x.png"
              />
              <div class="item-title">海量订单</div>
              <section class="item-desc">
                <div class="desc-item">平台每天上万订单</div>
                <div class="desc-item">抢单随你喜欢</div>
              </section>
            </section>
            <section class="reason-item">
              <img
                class="item-icon"
                src="../assets/views/requirement-money@2x.png"
              />
              <div class="item-title">收入可观</div>
              <section class="item-desc">
                <div class="desc-item">多劳多得</div>
                <div class="desc-item">收入高涨</div>
              </section>
            </section>
            <section class="reason-item">
              <img
                class="item-icon"
                src="../assets/views/requirement-car@2x.png"
              />
              <div class="item-title">接单自由</div>
              <section class="item-desc">
                <div class="desc-item">自主把握时间</div>
                <div class="desc-item">自由接单</div>
              </section>
            </section>
          </section>
        </div>
        <div
          class="join-detail"
          v-for="(joinItem, index) in joinDataList"
          :key="index"
        >
          <div class="title">
            <span class="line"></span>
            <span class="text">{{ joinItem.title }}</span>
            <span class="line"></span>
          </div>
          <div class="list" v-for="(list, i) in joinItem.detail" :key="i">
            <div class="list-title" v-if="list.title">
              <span>{{ list.title }}</span>
            </div>
            <section
              class="list-item"
              v-for="(listItem, j) in list.list"
              :key="j"
            >
              <span class="point"></span>
              <div class="item" v-for="(item, k) in listItem" :key="k">
                {{ item }}
              </div>
            </section>
          </div>
        </div>
        <div class="phone">
          <span class="desc">如有疑问请拨打客服热线咨询：</span>
          <a class="number" href="tel:0755-33841120">0755-33841120</a>
        </div>
      </div>
    </section>
    <section class="bottom">
      <div class="bottom-btn" type="primary" size="large" @click="join">
        我要加入
      </div>
    </section>
  </section>
</template>

<script>
export default {
  data() {
    return {
      joinDataList: [
        {
          title: '加入条件',
          detail: [
            {
              title: '总则',
              list: [
                [
                  '注册为驾驶员的司机用户应保证提供的证件资料真实、清晰、完整且在有效期内'
                ]
              ]
            },
            {
              title: '驾驶员要求',
              list: [
                ['年龄：女性21-55周岁, 男性21-60周岁；'],
                ['驾龄：3年以上；'],
                [
                  '准驾车型：机动车驾驶证载明的准驾车型为A1、A2、A3、B1、B2、C1或C2;'
                ],
                [
                  '安全驾驶：无交通肇事记录、危险驾驶记录、暴力犯罪记录、饮酒后驾驶记录，无吸毒记录; 最近连续3个计分周期内没有记满12分;'
                ],
                ['身体健康：未患有妨碍安全驾驶机动车的身体疾病;'][
                  '其它：无不良行为记录，且需符合各地方法律法规规定的准入标准;'
                ]
              ]
            },
            {
              title: '车辆要求',
              list: [
                ['核定载人数5-7人的小型或微型汽车，且非政府共用车；'],
                [
                  '车辆行驶里程少于60万公里且车龄小于8年，保险齐全且有效，年审有效期内；'
                ],
                [
                  '注册需提供：身份证、驾驶证、行驶证；若当地法律法规需办理《网络预约出租汽车驾驶员证》、《网络预约出租汽车运输证》，需从其规定按时办理。'
                ]
              ]
            }
          ]
        },
        {
          title: '加入流程',
          detail: [
            {
              title: '',
              list: [
                [
                  '下载小拉出行APP提交注册信息，包含司机、车辆信息，并完成本人人脸验证；'
                ],
                ['工作人员会在1个工作日内完成资料审核并反馈审核结果；'],
                ['认证通过后，就开始登录「小拉出行司机版」接单赚钱啦']
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    join() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="less" scoped>
@import '../assets/common/mixin.less';
@xl-color: #ff4553;
.page {
  box-sizing: border-box;
}

.header {
  .border-bottom(rgba(0, 0, 0, 0.12));
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 100;
  box-sizing: border-box;
}

.content {
  padding-bottom: 110px;
  box-sizing: border-box;
}

.top {
  position: relative;
  .top-bg {
    display: block;
    width: 100%;
  }
  .top-title {
    position: absolute;
    left: 0;
    bottom: 54px;
    width: 100%;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
}

.reason-container {
  .title {
    margin-top: 48px;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }
}

.reason-list {
  margin-top: 40px;
  display: flex;
  .reason-item {
    flex: 1;
    text-align: center;
  }
  .item-icon {
    width: 90px;
  }
  .item-title {
    margin-top: 4px;
    font-size: 28px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }
  .item-desc {
    margin-top: 10px;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.65);
  }
}

.join-detail {
  padding: 48px 52px 0;
  box-sizing: border-box;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 36px;
    color: #212121;
    .text {
      margin: 0 16px;
    }
    .line {
      width: 40px;
      height: 2px;
      box-sizing: border-box;
      .border-bottom(#000);
    }
  }
  .list {
    margin-top: 32px;
  }
}

.list-title {
  margin-top: 8px;
  margin-bottom: 24px;
  span {
    position: relative;
    font-size: 32px;
    color: #212121;
    &::after {
      content: '';
      position: absolute;
      left: -2px;
      bottom: 0;
      display: inline-block;
      right: -2px;
      height: 20px;
      z-index: -4;
      background: linear-gradient(
        180deg,
        rgba(255, 159, 0, 0) 0%,
        @xl-color 100%
      );
    }
  }
}

.list-item {
  margin-top: 16px;
  position: relative;
  .point {
    position: absolute;
    left: 0;
    top: 18px;
    width: 8px;
    height: 8px;
    opacity: 0.35;
    background: #000000;
    border-radius: 4px;
  }
  .item {
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 28px;
    color: rgba(33, 33, 33, 1);
    opacity: 0.65;
  }
}

.phone {
  margin-top: 32px;
  padding-left: 68px;
  box-sizing: border-box;
  font-size: 28px;
  .desc {
    color: rgba(33, 33, 33, 1);
    opacity: 0.65;
  }
  .number {
    color: @xl-color;
  }
}

.bottom {
  width: 100%;
  padding: 0 24px 20px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
  .bottom-btn {
    height: 88px;
    border-radius: 44px;
    color: #fff;
    background-color: #ff4553;
    border: 1px solid #ff4553;
    line-height: 88px;
    text-align: center;
    font-size: 36px;
  }
}
</style>
